import React from 'react'
import { useTranslation } from 'i18n'
import IconListItem from './IconListItem'
import UploadButton from './UploadButton'
import ReceiptViewHeader from 'steps/receipt/components/ReceiptViewHeader'
import './HowItWorksView.scss'
import UploadByCamera from 'components/UploadByCamera'

const HowItWorksView = ({
  mediaAccepted,
  onUploadError,
  themeColors,
  handleFileSelection,
  setPosition,
  headline,
  introCopy,
  headerImage,
  instructions = [],
  userPathHeadline,
  mediaUploadButtonString,
  iconBackgroundClr,
  iconBorderClr,
  openUploadModal = function () {},
  skipReceipt = function () {},
}) => {
  const { t } = useTranslation('ugcMediaUpload')
  const { primaryCopyColor, primaryColorButtons } = themeColors
  //respect order properties in beaker.config.js
  const sortedInstructions = instructions.sort(
    (a, b) => a.displayOrder - b.displayOrder,
  )
  return (
    <div className="receipt-view how-it-works-view">
      <ReceiptViewHeader
        headline={headline}
        introCopy={introCopy}
        headerImage={headerImage}
      />
      <div className={`receipt-view-content`}>
        {instructions && (
          <ul className={`how-it-works-list`}>
            {sortedInstructions.map((instruction, index) => {
              return (
                <IconListItem
                  key={index}
                  {...instruction}
                  iconBackgroundClr={'#FFFFFF'}
                  iconBorderClr={primaryCopyColor}
                />
              )
            })}
          </ul>
        )}
      </div>
      {userPathHeadline && (
        <h3
          className="receipt-path-headline step-content__title"
          dangerouslySetInnerHTML={{ __html: userPathHeadline }}
        />
      )}
      <div className={`receipt-button-container`} style={{ gap: '15px' }}>
        <button
          className="btn themed-button-secondary"
          onClick={() => {
            setPosition(3)
          }}
        >
          {t('notYet')}
        </button>
        <UploadButton
          mediaAccepted={mediaAccepted}
          onFileSelection={handleFileSelection}
          maxFiles={1}
          label={mediaUploadButtonString}
          onError={onUploadError}
          className="btn themed-button"
        />
        <UploadByCamera
          onUpload={handleFileSelection}
          onError={onUploadError}
          className="receipt-upload-button"
          buttonClassName="btn themed-button"
          mediaAccepted={mediaAccepted}
        />
      </div>
    </div>
  )
}
export default HowItWorksView
